import React, { FC } from 'react';

interface LogoProps {
  name: 'awayz' | 'ccc-horizontal';
  className?: string;
}

const Logo: FC<LogoProps> = ({ name, className }) => {
  return (
    <img
      src={`/logos/${name}.png`}
      alt={name}
      className={`max-w-[80vw] ${className}`}
    />
  );
};

export default Logo;
